import { Instant } from "@js-joda/core";
import { AbandonedVehicleCompressed, AbandonedVehicleChangeCompressed, AbandonedVehicleAttributesCompressed, AbandonedVehicleAttributes, AbandonedVehicleReviewChangeCompressed } from "../api/Application";
import { AbandonedVehicleReviewStatus, AbandonedVehicleStatus, VehicleSituation } from "../api/Network";

export enum AbandonedVehicleSituation {
    Street = 1,
    Lot    = 2,
    Drive  = 3
}

export function showDisplayVehicleSituation( style: AbandonedVehicleSituation | null ): string {
    switch( style ) {
        case AbandonedVehicleSituation.Street: return "Street";
        case AbandonedVehicleSituation.Lot:    return "Lot";
        case AbandonedVehicleSituation.Drive:  return "Drive";
        default: 
            return "Not Set";
    }    
}

const sitMap = new Map<VehicleSituation, AbandonedVehicleSituation>(); 
sitMap.set( VehicleSituation.Street,     AbandonedVehicleSituation.Street );      
sitMap.set( VehicleSituation.Shoulder,   AbandonedVehicleSituation.Street );    
sitMap.set( VehicleSituation.Sidewalk,   AbandonedVehicleSituation.Street );    
sitMap.set( VehicleSituation.Alleyway,   AbandonedVehicleSituation.Drive  );    
sitMap.set( VehicleSituation.Driveway,   AbandonedVehicleSituation.Drive  );    
sitMap.set( VehicleSituation.Field,      AbandonedVehicleSituation.Lot    );       
sitMap.set( VehicleSituation.ParkingLot, AbandonedVehicleSituation.Lot    );  
sitMap.set( VehicleSituation.Junkyard,   AbandonedVehicleSituation.Lot    );    
sitMap.set( VehicleSituation.Worksite,   AbandonedVehicleSituation.Lot    );    
sitMap.set( VehicleSituation.Industrial, AbandonedVehicleSituation.Lot    );

export function mapSituation( s: VehicleSituation | null ) {
    if( s === null ) {
        return null;
    }
    const res = sitMap.get( s );
    if( res !== undefined ) { 
        return res;
    }
    return null;
}

export enum DisplayVehicleType {
    Car    = 1,
    Pickup = 2,
    Suv    = 3
}

export function showDisplayVehicleType( style: DisplayVehicleType | null ): string {
    switch( style ) {
        case DisplayVehicleType.Car:    return "Car";
        case DisplayVehicleType.Pickup: return "Pickup";
        case DisplayVehicleType.Suv:    return "SUV";
        default: 
            return "Unset";
    }    
}

export interface AbandonedVehicleSmall {
    abandonedVehicleId: number;
    x:                  number;
    y:                  number;
    width:              number;
    height:             number;
    angle:              number;
    confidence:         number;
    similarity:         number;
    displaySituation:   AbandonedVehicleSituation | null;
    displayVehicleType: DisplayVehicleType | null;
    attributes:         AbandonedVehicleAttributes;
    status:             AbandonedVehicleChangeSmall;
    reviewStatus:       AbandonedVehicleReviewSmall | null;
 // changes:            AbandonedVehicleChangeSmall[];
}

export interface AbandonedVehicleReviewSmall {
    status:      AbandonedVehicleReviewStatus;
    createdWhen: Instant;
}

export interface AbandonedVehicleChangeSmall {    
    status:      AbandonedVehicleStatus;
    createdWhen: Instant;
}

export function expandAbandonedVehicleChangeCompressed( v: AbandonedVehicleChangeCompressed ): AbandonedVehicleChangeSmall {
    return {
        status:      v.c,
        createdWhen: v.d,
    };
}

export function expandAbandonedVehicleReviewChangeCompressed( v: AbandonedVehicleReviewChangeCompressed ): AbandonedVehicleReviewSmall {
    return {
        status:      v.c,
        createdWhen: v.d,
    };
}

export function expandAbandonedVehicle( v: AbandonedVehicleCompressed ): AbandonedVehicleSmall {
    return {
        abandonedVehicleId: v.a,
        x:                  v.x,
        y:                  v.y,
        width:              v.w,
        height:             v.h,
        angle:              v.t,
        confidence:         v.c,
        similarity:         v.s,
        displaySituation:   mapSituation( v.at.si ),
        displayVehicleType: v.at.vt as any,
        attributes:         expandAbandonedVehicleAttributes( v.at ),
        status:             expandAbandonedVehicleChangeCompressed( v.st ),
        reviewStatus:       v.rs !== null ? expandAbandonedVehicleReviewChangeCompressed( v.rs ) : null
    };
}

export function expandAbandonedVehicleAttributes( v: AbandonedVehicleAttributesCompressed ): AbandonedVehicleAttributes {
    return {
        landUse:     v.lu,
        vehicleType: v.vt,
        situation:   v.si,
        area:        v.ar,
        address:     v.ad
    };
}